<template>
  <div
    class="plv-iar-order-product-card"
    :class="{
      'plv-iar-order-product-card--order': inOrderTheme
    }"
  >
    <div class="plv-iar-opc-cover-box">
      <img class="plv-iar-opc-cover" :src="dataSource.cover || dataSource.productCover" :alt="dataSource.name || dataSource.productName" />
    </div>
    <div class="plv-iar-opc-info">
      <div class="plv-iar-opc-title plv-iar-opc-ellipsis">{{ dataSource.name || dataSource.productName }}</div>
      <!-- S 标签 -->
      <div class="plv-iar-opc-tag-wrap" v-if="tags.length">
        <div class="plv-iar-opc-tag" v-for="(tag, index) in tags" :key="index">{{ tag }}</div>
      </div>
      <!-- E 标签 -->
      <p class="plv-iar-opc-desc plv-iar-opc-ellipsis" v-if="dataSource.productDesc">{{ dataSource.productDesc }}</p>
      <!-- S 价格信息 -->
      <div class="plv-iar-opc-price-wrap">
        <span v-if="dataSource.realPrice || dataSource.amount" class="plv-iar-opc-price-unit">￥</span>
        <span class="plv-iar-opc-price">{{ dataSource.realPrice || dataSource.amount || iarTrans('product.free') }}</span>
        <span class="plv-iar-opc-price-original">{{ formatPrice(dataSource.price) }}</span>
      </div>
      <!-- E 价格信息 -->
    </div>
  </div>
</template>

<script>
import { tryParseJSON } from '@polyv/utils/src/lang';
import langs from '../../assets/locale/lang/product';
import entryMixin from '../../assets/mixins/entry';

export default {
  langs,

  mixins: [entryMixin],

  props: {
    dataSource: {
      type: Object,
      default: () => {}
    },

    inOrderTheme: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /** 商品标签 */
    tags() {
      if (!this.dataSource || !this.dataSource.features) return [];

      return tryParseJSON(this.dataSource.features) || [];
    }
  },

  methods: {
    /**
     * @description: 格式化价格
     * @param {string} price
     * @return {string}
     */
    formatPrice(price) {
      return price ? `￥${price}` : '';
    }
  }
};
</script>

<style lang="scss">
.plv-iar-order-product-card {
  display: flex;
  font-size: 14px;
  padding: 10px;
  border-radius: 8px;
  background: #fff;

  .plv-iar-opc-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .plv-iar-opc-cover-box {
    flex-shrink: 0;
    overflow: hidden;
    margin-right: 8px;
    width: 104px;
    height: 104px;
    border-radius: 8px;
  }

  .plv-iar-opc-cover {
    display: block;
    width: 100%;
    height: 100%;
  }

  .plv-iar-opc-info {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .plv-iar-opc-title {
    margin-bottom: 6px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }

  .plv-iar-opc-tag-wrap {
    overflow: hidden;
    margin-bottom: 6px;
    white-space: nowrap;
  }

  .plv-iar-opc-tag {
    display: inline-block;
    margin-left: 4px;
    padding: 1px 4px;
    font-size: 10px;
    font-weight: 500;
    color: #F15D5D;
    border: 0.5px solid rgba(255, 99, 99, 0.6);
    border-radius: 2px;

    &:first-of-type {
      margin-left: 0;
    }
  }

  .plv-iar-opc-desc {
    margin: 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }

  .plv-iar-opc-price-wrap {
    margin-top: auto;
    font-size: 12px;
  }

  .plv-iar-opc-price-unit {
    color: #F15D5D;
  }

  .plv-iar-opc-price {
    font-size: 18px;
    color: #F15D5D;
  }

  .plv-iar-opc-price-original {
    text-decoration: line-through;
    color: rgba(0, 0, 0, 0.4);
  }
}

.plv-iar-order-product-card--order {
  .plv-iar-opc-title {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal !important;
    margin-bottom: unset !important;
  }

  .plv-iar-opc-price-unit,
  .plv-iar-opc-price {
    color: #333333 !important;
  }
}
</style>
